import { render, staticRenderFns } from "./DocumentationControl.vue?vue&type=template&id=7e466274&"
import script from "./DocumentationControl.vue?vue&type=script&lang=js&"
export * from "./DocumentationControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports